export const emojiMap = {
  // Emociones
  feliz: '😊',
  triste: '😢',
  enojado: '😠',
  sorprendido: '😲',
  risa: '😂',
  llorando: '😭',
  sonriendo: '😊',
  pensando: '🤔',
  confundido: '😕',
  asustado: '😨',
  dormido: '😴',
  enamorado: '🥰',
  cool: '😎',
  guino: '😉',
  beso: '😘',

  // Objetos
  corazon: '❤️',
  estrella: '⭐',
  sol: '☀️',
  luna: '🌙',
  fuego: '🔥',
  caja: '📦',
  llave: '🔑',
  reloj: '⏰',
  libro: '📚',
  lapiz: '✏️',
  telefono: '📱',
  computadora: '💻',
  camera: '📷',
  bateria: '🔋',
  bombilla: '💡',
  paraguas: '☂️',
  maleta: '💼',
  regalo: '🎁',
  corona: '👑',
  diamante: '💎',

  // Animales
  perro: '🐕',
  gato: '🐱',
  pollo: '🐔',
  vaca: '🐄',
  cerdo: '🐷',
  conejo: '🐰',
  panda: '🐼',
  leon: '🦁',
  tigre: '🐯',
  elefante: '🐘',
  jirafa: '🦒',
  mono: '🐒',
  pinguino: '🐧',
  delfin: '🐬',
  ballena: '🐋',
  tortuga: '🐢',
  rana: '🐸',
  mariposa: '🦋',
  abeja: '🐝',
  araña: '🕷️',

  // Comida
  pizza: '🍕',
  hamburguesa: '🍔',
  helado: '🍦',
  cafe: '☕',
  cerveza: '🍺',
  manzana: '🍎',
  banana: '🍌',
  naranja: '🍊',
  uva: '🍇',
  fresa: '🍓',
  sandia: '🍉',
  melon: '🍈',
  kiwi: '🥝',
  aguacate: '🥑',
  zanahoria: '🥕',
  lechuga: '🥬',
  tomate: '🍅',
  cebolla: '🧅',
  ajo: '🧄',
  pan: '🍞',
  queso: '🧀',
  huevo: '🥚',
  carne: '🥩',
  'pollo-asado': '🍗',
  pescado: '🐟',
  camaron: '🦐',
  sopa: '🍲',
  ensalada: '🥗',
  taco: '🌮',
  sushi: '🍣',
  ramen: '🍜',
  donut: '🍩',
  galleta: '🍪',
  pastel: '🎂',
  chocolate: '🍫',
  caramelo: '🍬',
  paleta: '🍭',

  // Actividades
  futbol: '⚽',
  basketball: '🏀',
  musica: '🎵',
  tenis: '🎾',
  golf: '⛳',
  natacion: '🏊',
  ciclismo: '🚴',
  esqui: '⛷️',
  surf: '🏄',
  yoga: '🧘',
  gimnasio: '🏋️',
  baile: '💃',
  pintura: '🎨',
  escritura: '✍️',
  lectura: '📖',
  juego: '🎮',
  puzzle: '🧩',
  ajedrez: '♟️',
  dados: '🎲',
  cartas: '🃏',
  karaoke: '🎤',
  guitarra: '🎸',
  piano: '🎹',
  trompeta: '🎺',
  violin: '🎻',
  tambor: '🥁',

  // Naturaleza
  flor: '🌸',
  arbol: '🌳',
  mar: '🌊',
  montaña: '⛰️',
  nube: '☁️',
  lluvia: '🌧️',
  nieve: '❄️',
  viento: '💨',
  arcoiris: '🌈',
  volcan: '🌋',
  desierto: '🏜️',
  bosque: '🌲',
  pradera: '🌾',
  cactus: '🌵',
  roca: '🪨',
  cristal: '💎',
  hoja: '🍃',
  semilla: '🌱',
  brote: '🌿',
  musgo: '🍄',
  seta: '🍄',
  rosa: '🌹',
  tulipan: '🌷',
  girasol: '🌻',
  lirio: '🌺',
  margarita: '🌼',
  clavel: '🌺',

  // Símbolos
  check: '✅',
  x: '❌',
  pregunta: '❓',
  exclamacion: '❗',
  rayo: '⚡',
  paz: '☮️',
  'yin-yang': '☯️',
  infinito: '♾️',
  recycle: '♻️',
  bio: '🔄',
  plus: '➕',
  minus: '➖',
  multiply: '✖️',
  divide: '➗',
  equals: '🟰',
  percent: '💯',
  copyright: '©️',
  registered: '®️',
  trademark: '™️',
  warning: '⚠️',
  prohibido: '🚫',
  'no-entry': '⛔',
  radioactive: '☢️',
  biohazard: '☣️',
  skull: '💀',
  cross: '✝️',
  'star-david': '✡️',
  crescent: '☪️',
  om: '🕉️',
  wheel: '☸️',

  // Transporte
  carro: '🚗',
  moto: '🏍️',
  bicicleta: '🚲',
  autobus: '🚌',
  tren: '🚆',
  avion: '✈️',
  barco: '🚢',
  helicoptero: '🚁',
  cohete: '🚀',
  ufo: '🛸',
  satelite: '🛰️',
  taxi: '🚕',
  ambulancia: '🚑',
  bomberos: '🚒',
  policia: '🚓',
  camion: '🚛',
  tractor: '🚜',
  bote: '⛵',
  yate: '🛥️',
  submarino: '🛳️',

  // Lugares
  casa: '🏠',
  edificio: '🏢',
  hospital: '🏥',
  escuela: '🏫',
  iglesia: '⛪',
  mezquita: '🕌',
  templo: '🕍',
  pagoda: '🗼',
  castillo: '🏰',
  palacio: '🏛️',
  torre: '🗼',
  puente: '🌉',
  estatua: '🗽',
  faro: '🗼',
  ruinas: '🏛️',
  tienda: '🏪',
  restaurante: '🍽️',
  hotel: '🏨',
  banco: '🏦',
  gasolinera: '⛽',
  parking: '🅿️',
  wc: '🚻',
  playa: '🏖️',
  isla: '🏝️',
  parque: '🏞️',
  jardin: '🌳',
  granja: '🏡',
  campo: '🌾',

  // Tecnología
  wifi: '📶',
  bluetooth: '📡',
  usb: '💾',
  cd: '💿',
  dvd: '📀',
  disco: '💽',
  cable: '🔌',
  enchufe: '🔌',
  cargador: '🔌',
  radar: '📡',
  microchip: '💻',
  robot: '🤖',
  alien: '👽',
  astronauta: '👨‍🚀',
  telescopio: '🔭',
  microscopio: '🔬',
  laboratorio: '🧪',
  atom: '⚛️',
  dna: '🧬',
  virus: '🦠',
  vacuna: '💉',
  pildora: '💊',
  termometro: '🌡️',
  estetoscopio: '🩺',
  radiografia: '📷',
  'cruz-roja': '🏥',

  // Deportes
  baloncesto: '🏀',
  beisbol: '⚾',
  voleibol: '🏐',
  rugby: '🏉',
  hockey: '🏒',
  'ping-pong': '🏓',
  badminton: '🏸',
  boliche: '🎳',
  dardos: '🎯',
  tiro: '🎯',
  esgrima: '🤺',
  boxeo: '🥊',
} as const;
